import * as React from 'react';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';
import { Box } from '@mui/system';

import { theme } from 'ui/theme';

interface Props {
  label: string | React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => any;
  url?: string;
  dataCy?: string;
  newTab?: boolean;
  color?: 'link' | 'subtle' | 'green';
  style?: React.CSSProperties;
  containerSx?: SxProps<Theme>;
  type?: 'body3' | 'body4';
}

export const Hyperlink: React.FC<Props> = ({
  label,
  onClick,
  url,
  dataCy,
  newTab,
  color,
  style,
  containerSx = {},
  type = 'body1'
}) => {
  const prefix =
    url?.indexOf('http') === -1 && url?.indexOf('mailto:') === -1 && url?.indexOf('tel:') === -1 ? '//' : '';
  const textStyles =
    type === 'body3'
      ? {
          fontFamily: 'Lato',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '13px',
          lineHeight: '140%'
        }
      : type === 'body4'
      ? {
          fontFamily: 'Lato',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '140%'
        }
      : {};

  let containerStyles = {
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      minHeight: '1px',
      minWidth: '1px',
      '&:hover': {
        cursor: 'pointer',
        color: '#1270FC'
      },
      ...textStyles,
      ...style
    }
  };

  containerStyles = {
    ...containerStyles,
    ...containerSx
  };

  return (
    <Box component={'span'} sx={containerStyles}>
      <a
        href={url ? prefix + url : undefined}
        data-cy={dataCy}
        target={newTab ? '_blank' : ''}
        onClick={(e) => onClick && onClick(e)}
        rel={url?.includes('mailto:') ? 'noopener noreferrer' : undefined}
      >
        {label}
      </a>
    </Box>
  );
};
